export const GET_ROLE_LIST_REQUEST = 'GET_ROLE_LIST_REQUEST';
export const GET_ROLE_LIST_SUCCESS = 'GET_ROLE_LIST_SUCCESS';
export const GET_ROLE_LIST_FAILED = 'GET_ROLE_LIST_FAILED';

export const GetRoleListAction = () => {
    return { type: GET_ROLE_LIST_REQUEST };
};